import styled from 'styled-components'

export const StyledSelectDiv = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: column;

  [role='combobox'] {
    background-color: ${({ theme }) => theme.forecast.background1} !important;
    border: 1px ${({ theme }) => theme.forecast.border2} solid !important;
    color: ${({ theme }) => theme.forecast.activeText};
  }

  span[role='alert'] {
    color: red;
  }

  &::placeholder {
    color: ${({ theme }) => theme.forecast.textDisabled} !important;
  }
`
